<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4.00001 12 4.00001C7.58 4.00001 4 7.58001 4 12C4 16.42 7.58 20 12 20ZM11 7L13 7L13 9L11 9L11 7ZM13 11L11 11L11 17L13 17L13 11Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.52 17.53 22 12.01 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12.01 2C17.53 2 22 6.48 22 12ZM20 12C20 7.58 16.42 4.00001 12 4.00001C7.57998 4.00001 3.99999 7.58001 3.99999 12C3.99999 16.42 7.57999 20 12 20C16.42 20 20 16.42 20 12Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path d="M13 9L11 9L11 7L13 7L13 9Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path d="M13 17L11 17L11 11L13 11L13 17Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>